module.exports = __webpack_public_path__ + "static/img/Frame 1860.b03c5d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls3/Frame 1860.png
// module id = Juc3
// module chunks = 12